import { when } from 'mobx';
import { once } from '../../js/utils';
import { MraidStore } from '../MraidStore';
import { FormatStateStore, FormatState } from '../FormatStateStore';

interface MraidOnAdLoadedCallHandlerProps {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
}
export class MraidOnAdLoadedCallHandler {
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;

  constructor({
    mraidStore,
    formatStateStore
  }: MraidOnAdLoadedCallHandlerProps) {
    this.mraidStore = mraidStore;
    this.formatStateStore = formatStateStore;

    this.formatHasLoaded = once(this.formatHasLoaded);

    when(
      () =>
        this.formatStateStore.state === FormatState.Loaded &&
        this.mraidStore.isReady === true,
      () => this.formatHasLoaded()
    );
  }

  formatHasLoaded() {
    this.mraidStore.triggerOnAdLoaded();
  }
}
